import { StandardEvents } from '@shopify/events';
import { ThemeEvents } from '@theme/events';
class LhdProductHelp extends HTMLElement {
  connectedCallback() {
    this.section = this.closest('.shopify-section, dialog');
    this.scope = this.closest('.product-details') || this.section;
    this.addEventListener('click', this.chooseBundle);
    this.scope?.addEventListener(ThemeEvents.quantitySelectorUpdate, this.syncQuantity);
    this.section?.addEventListener(StandardEvents.productSelect, this.updateSummary);
    customElements.whenDefined('quantity-selector-component').then(() => { if(this.isConnected) this.syncQuantity(); });
  }
  disconnectedCallback() {
    this.removeEventListener('click', this.chooseBundle);
    this.scope?.removeEventListener(ThemeEvents.quantitySelectorUpdate, this.syncQuantity);
    this.section?.removeEventListener(StandardEvents.productSelect, this.updateSummary);
  }
  get selector() { return this.scope?.querySelector('product-form-component quantity-selector-component'); }
  syncQuantity = () => {
    const selector = this.selector, input = selector?.querySelector('input[name="quantity"]');
    const value = Number(input?.value), min = Number(input?.min || 1), step = Number(input?.step || 1);
    const max = input?.max ? Number(input.max) - Number(input.dataset.cartQuantity || 0) : Infinity;
    this.querySelectorAll('[data-set-quantity]').forEach(button => {
      const count = Number(button.dataset.setQuantity);
      button.setAttribute('aria-pressed', String(count === value));
      button.disabled = this.pending || !input || input.disabled || count < min || count > max || (count-min)%step !== 0;
    });
  };
  chooseBundle = event => {
    const button = event.target.closest('[data-set-quantity]');
    const selector = this.selector;
    if (!button || button.disabled || !selector?.setValue) return;
    selector.setValue(button.dataset.setQuantity);
    selector.onQuantityChange();
    selector.updateButtonStates();
    const disclosure = selector.closest('.lhd-custom-quantity');
    if (disclosure) disclosure.open = false;
    this.syncQuantity();
  };
  updateSummary = event => {
    if (!(event.target instanceof Element) || event.target.closest('product-card')) return;
    const request = this.request = (this.request || 0) + 1;
    this.pending = true;
    this.syncQuantity();
    event.promise.then(({ detail }) => {
      if (!this.isConnected || this.request !== request) return;
      const next = [...(detail?.html?.querySelectorAll('lhd-product-help') || [])].find(el => el.dataset.blockId === this.dataset.blockId);
      const replacement = next?.querySelector('[data-lhd-summary]');
      const current = this.querySelector('[data-lhd-summary]');
      if (replacement && current) { current.replaceWith(replacement.cloneNode(true)); this.pending = false; this.syncQuantity(); }
      else if (current) current.textContent = 'Sélectionnez une taille disponible pour afficher le prix de la paire.';
    }).catch(() => {
      if(this.request !== request) return;
      const current=this.querySelector('[data-lhd-summary]');
      if(current) current.textContent = 'Le prix de la paire n’a pas pu être actualisé. Rechargez la page pour réessayer.';
    });
  };
}
if (!customElements.get('lhd-product-help')) customElements.define('lhd-product-help', LhdProductHelp);
